module.exports = __webpack_public_path__ + "static/img/funcsInfo.8b7c49b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/funcsInfo.png
// module id = zKCv
// module chunks = 4